import React, { useEffect, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { resetQuiz } from 'redux/reducers/quiz'
import { Button, CircularProgress, Icons } from 'components/Antifraude'
import validateStageOnboarding from 'utils/validateStage'
import { roles } from 'utils/constants/roles'
import { FailContainer } from './styles'


export default (props) => {
  const { history } = props
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const { token } = useSelector((state) => state.token)

  const handleLoading = (newState) => {
    setLoading(newState)
  }

  useEffect(() => {
    validateStageOnboarding(token, history, roles.QUIZ, handleLoading)
  }, [])

  function handleRetry() {
    history.replace(`/quiz`)
  }

  useEffect(() => {
    dispatch(resetQuiz())
  }, [])

  return loading ? (
    <div className="loading">
      <div
        className="loading__container"
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        <CircularProgress style={{ textAlign: 'center' }} />
      </div>
    </div>
  ) : (
    <FailContainer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <h1>Algo deu errado!</h1>
      <h4>Não conseguimos validar as respostas!</h4>

      <div className="hint">
        <Icons icon="light" />
        <p>Leia atentamente as questões e responda antes do tempo terminar.</p>
      </div>
      <Button onClick={handleRetry}>
        Tentar novamente
      </Button>
    </FailContainer>
  )
}
